export const clockFilterLabels = [
  { hasNotch: true, label: '00:00', position: 0 },
  {
    hasNotch: true,
    label: '05:00',
    position: 300,
  },
  {
    hasNotch: true,
    label: '10:00',
    position: 600,
  },
  {
    hasNotch: true,
    label: '15:00',
    position: 900,
  },
];
